import ApiService from "../util/api.service";
import { SERVICE_CONFIG_URLS } from "./config";

const AnalyticsService = {
  getUsersData,
  getTotalSharedCount,
  getNonActiveUsers,
  getAverageAppActivity,
  getParentVisits,
  getTimeSpentApp,
  getUserStatistic,
  getUserLocReports,
  getSearchStatistic,
  getTimeSpentSection,
  getContentStatistics,
  getPushNotificationApp,
  getTotalUsersZipCode,
  getGeneralTagGroupedCount,
  getParentsByChildrenCount,
  getInterestTagsPressCount,
  getTotalFavoriteCount,
  getUserActivitySummary,
  getActiveUsers,
  getOnboardingTime,
  getParentVisitsSection,
  getViewedEvents,
  getConnectProfileEvents,
  getDemographics,
  getTotalSearches,
  getEmailsByUserIds,
};

async function getUserActivitySummary() {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_USER_ACTIVITY_SUMMARY
  );
  return response;
}

async function getTotalSharedCount(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_TOTAL_SHARED_COUNT,
    payload
  );
  return response;
}
async function getTotalFavoriteCount(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_TOTAL_FAVORITE_COUNT,
    payload
  );
  return response;
}
async function getUsersData() {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_USERS_DATA
  );
  return response;
}
async function getGeneralTagGroupedCount() {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_GENERAL_TAG_GROUPED_COUNT
  );
  return response;
}
async function getParentsByChildrenCount() {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_PARENTS_BY_CHILDREN_COUNT
  );
  return response;
}
async function getInterestTagsPressCount(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_INTEREST_TAGS_PRESS_COUNT,
    payload
  );
  return response;
}
async function getActiveUsers(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_ACTIVE_USERS,
    payload
  );
  return response;
}
async function getNonActiveUsers(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_NON_ACTIVE_USERS,
    payload
  );
  return response;
}
async function getTotalSearches(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_TOTAL_SEARCHES,
    payload
  );
  return response;
}
async function getOnboardingTime(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_ONBOARDING_TIME,
    payload
  );
  return response;
}
async function getAverageAppActivity(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_AVERAGE_APP_ACTIVITY,
    payload
  );
  return response;
}
async function getContentStatistics(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_CONTENT_STATISTICS,
    payload
  );
  return response;
}

async function getParentVisitsSection(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.PARENTS_VISIT_SECTION,
    payload
  );
  return response;
}
async function getTimeSpentSection(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.TIME_SPENT_SECTION,
    payload
  );
  return response;
}
async function getParentVisits(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_PARENTS_VISITS,
    payload
  );
  return response;
}
async function getTimeSpentApp(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.TIME_SPENT_APP,
    payload
  );
  return response;
}
async function getPushNotificationApp(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.PUSH_NOTIFICATION,
    payload
  );
  return response;
}

async function getTotalUsersZipCode(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.TOTAL_USERS_ZIP_CODE,
    payload
  );
  return response;
}
async function getUserLocReports(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.USER_LOCATIONS_REPORT,
    payload
  );
  return response;
}

async function getUserStatistic(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.USER_STATISTIC,
    payload
  );
  return response;
}

async function getSearchStatistic(payload) {
  const response = await ApiService.get(
    SERVICE_CONFIG_URLS.ANALYTICS.SEARCH_STATISTIC,
    payload
  );
  return response;
}

async function getViewedEvents(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_VIEWED_EVENTS,
    payload
  );
  return response;
}

async function getConnectProfileEvents(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_CONNECT_PROFILE_EVENTS,
    payload
  );
  return response;
}

async function getDemographics(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_DEMOGRAPHICS,
    payload
  );
  return response;
}

async function getEmailsByUserIds(payload) {
  const response = await ApiService.post(
    SERVICE_CONFIG_URLS.ANALYTICS.GET_EMAILS_BY_USER_IDS,
    payload
  );
  return response;
}

export default AnalyticsService;
